/**
 * @generated SignedSource<<ccd7fac87c5c8480ac64175400f01cc8>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type StatusValue = "ERROR" | "PARTIAL_SUCCESS" | "SKIPPED" | "SUCCESS" | "UNAVAILABLE" | "%future added value";
export type UpdateDatadogIntegrationInput = {
  apiKey?: string | null | undefined;
  appKey?: string | null | undefined;
  enabled?: boolean | null | undefined;
  site?: string | null | undefined;
};
export type UpdateDatadogIntegrationMutation$variables = {
  input: UpdateDatadogIntegrationInput;
};
export type UpdateDatadogIntegrationMutation$data = {
  readonly updateDatadogIntegration: {
    readonly datadogIntegration: {
      readonly configured: boolean;
      readonly enabled: boolean;
      readonly site: string;
      readonly statusInfo: {
        readonly details: ReadonlyArray<{
          readonly at: string | null | undefined;
          readonly component: string;
          readonly message: string | null | undefined;
          readonly runningSince: string | null | undefined;
          readonly status: StatusValue | null | undefined;
        }>;
        readonly status: StatusValue;
      };
    } | null | undefined;
    readonly problems: ReadonlyArray<{
      readonly message: string;
    }>;
  };
};
export type UpdateDatadogIntegrationMutation = {
  response: UpdateDatadogIntegrationMutation$data;
  variables: UpdateDatadogIntegrationMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "message",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "concreteType": "DatadogIntegration",
  "kind": "LinkedField",
  "name": "datadogIntegration",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "configured",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "enabled",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "site",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "StatusInfo",
      "kind": "LinkedField",
      "name": "statusInfo",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "StatusDetail",
          "kind": "LinkedField",
          "name": "details",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "at",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "component",
              "storageKey": null
            },
            (v2/*:: as any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "runningSince",
              "storageKey": null
            },
            (v3/*:: as any*/)
          ],
          "storageKey": null
        },
        (v3/*:: as any*/)
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "UpdateDatadogIntegrationMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "UpdateDatadogIntegrationPayload",
        "kind": "LinkedField",
        "name": "updateDatadogIntegration",
        "plural": false,
        "selections": [
          (v4/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "problems",
            "plural": true,
            "selections": [
              (v2/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "UpdateDatadogIntegrationMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "UpdateDatadogIntegrationPayload",
        "kind": "LinkedField",
        "name": "updateDatadogIntegration",
        "plural": false,
        "selections": [
          (v4/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "problems",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__typename",
                "storageKey": null
              },
              (v2/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "24461f92504edae9f8a51caa734a015f",
    "id": null,
    "metadata": {},
    "name": "UpdateDatadogIntegrationMutation",
    "operationKind": "mutation",
    "text": "mutation UpdateDatadogIntegrationMutation(\n  $input: UpdateDatadogIntegrationInput!\n) {\n  updateDatadogIntegration(input: $input) {\n    datadogIntegration {\n      configured\n      enabled\n      site\n      statusInfo {\n        details {\n          at\n          component\n          message\n          runningSince\n          status\n        }\n        status\n      }\n    }\n    problems {\n      __typename\n      message\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "d8ab04baacc02a92c3a1a097610e69a3";

export default node;
